// This is a hack store to allow us to slowly
// remove functionality from the exim store
// This will need to be an instance in time loaded by the user id
import { computed, observable } from 'mobx';
import z from 'z';

import { RoomResponse } from 'tm3-core/api.dtos';
import type {
  GeneralPractitionerResponse,
  LocationResponse,
  PractitionerLocation
} from 'tm3-core/api.dtos';
import { cache } from 'tm3-core/cache';
import EPractitionerStatus from 'tm3-core/interfaces/practitioner/enums/status';

class DiaryCacheStore {
  @computed
  get noRoom(): RoomResponse {
    return new RoomResponse({ description: z.format('None Assigned'), id: -2 });
  }

  @computed
  get loaded(): boolean {
    return cache.locations.loaded && cache.practitioners.loaded && cache.rooms.loaded;
  }

  @computed
  get allLocations(): LocationResponse[] {
    return cache.locations.All;
  }

  @computed
  get currentLocations(): LocationResponse[] {
    return cache.locations.CurrentLocations;
  }

  @computed
  get allRooms(): RoomResponse[] {
    return [this.noRoom, ...cache.rooms.Current];
  }

  @computed
  get allPractitioners(): GeneralPractitionerResponse[] {
    return cache.practitioners.All;
  }

  @computed
  get activePractitioners(): GeneralPractitionerResponse[] {
    return cache.practitioners.All.filter((x) => {
      return x.status !== EPractitionerStatus.inactive;
    });
  }

  @computed
  get allPractitionerLocations(): PractitionerLocation[] {
    return cache.practitionerLocations.All;
  }

  onLoad(): void {
    // do nothing
  }
}

const GlobalDiaryCacheStore = new DiaryCacheStore();

export default GlobalDiaryCacheStore;
